"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SchemaWrapper_1 = require("./SchemaWrapper");
var JSchema_1 = require("./JSchema");
var schemaMixin = {
    // beforeCreate() { },
    created: function () {
        var vm = this;
        var schema = vm.$options.schema;
        if (schema && vm.$setSchema) {
            vm.$setSchema(schema, false);
        }
    },
    beforeDestroy: function () {
        this.$setSchema();
    },
    methods: {
        $setSchema: function (schema, forceUpdate) {
            // remove previous
            var vm = this;
            var wrapobj = vm.$options._schemawrapper;
            if (wrapobj) {
                wrapobj.clear();
                vm.$schema = null;
            }
            if (!schema) {
                return null;
            }
            var options = vm.$options;
            // const schOptions = options.schemaOptions || {};
            wrapobj = new SchemaWrapper_1.SchemaWrapper(this.constructor, options.schemaOptions);
            // tslint:disable-next-line: no-console
            if (options.external) {
                // console.log('set external', options.external);
                wrapobj.external = vm.$external = options.external;
            }
            else {
                // wrapobj.basedata = vm.$external
            }
            vm.$options._schemawrapper = wrapobj;
            // if (options.form) {
            vm.$form = wrapobj.form = vm.form || options.form || {};
            // vm.$form = options.form;
            // }
            wrapobj.asyncArrays = false;
            // merge schema
            var schema2 = null;
            // let fixtime = new Date().getTime();
            if (process.env.NODE_ENV === 'development') {
                console.time('schema fixing time');
            }
            var fixOptions = Object.assign({}, JSchema_1.fixSchemaDefaultOptions);
            if ((options.schemaOptions) && (options.schemaOptions.arrayItemGuidField !== undefined)) {
                fixOptions.arrayItemGuidField = options.schemaOptions.arrayItemGuidField;
            }
            if (!Array.isArray(schema)) {
                schema = [schema];
            }
            else {
                schema = schema.slice(0);
            }
            if (options.beforeFixSchema) {
                options.beforeFixSchema(schema, fixOptions);
            }
            schema2 = JSchema_1.fixAndMergeSchema(schema, fixOptions);
            // let ooo = JSON.stringify(schema2);
            if (process.env.NODE_ENV === 'development') {
                console.timeEnd('schema fixing time');
            }
            // console.log('schema fixing time', new Date().getTime() - fixtime);
            // const stime = new Date().getTime();
            if (process.env.NODE_ENV === 'development') {
                console.time('wrapping schema');
            }
            // for (let i = 0; i < 100; i++) {
            // Object.defineProperty(this,"$schema",{
            //    enumerable: true,
            //    get: wrapobj.wrap(this, "model", schema)
            // })
            if (vm.model !== undefined) {
                if (vm.model === null) {
                    // tworzenie domyslnego
                    vm.model = JSchema_1.defaultValue(schema2, true);
                }
                else {
                    if (process.env.NODE_ENV === 'development') {
                        console.time('fixData');
                    }
                    var fixed = JSchema_1.fixData(schema2, vm.model, wrapobj.Vue);
                    if (process.env.NODE_ENV === 'development') {
                        console.timeEnd('fixData');
                        if (fixed) {
                            console.log('fixed fields: ' + fixed);
                        }
                    }
                }
                if (options.beforeSchema) {
                    options.beforeSchema(vm.model, schema2, wrapobj.options);
                }
                if (process.env.NODE_ENV === 'development') {
                    console.log('$schema.options', wrapobj.options);
                }
                // console.log('wrapping model', vm.model);
                vm.$schema = wrapobj.wrap(vm, schema2, 'model');
            }
            else {
                if (options.beforeSchema) {
                    options.beforeSchema(vm._data, schema2, wrapobj.options);
                }
                if (process.env.NODE_ENV === 'development') {
                    console.log('$schema.options', wrapobj.options);
                }
                // vm.$schema = wrapobj.wrap(vm, schema2, '_data');
                vm.$schema = wrapobj.wrap(vm._data, schema2);
            }
            if (options.afterSchema) {
                options.afterSchema(vm.$schema);
            }
            if (process.env.NODE_ENV === 'development') {
                console.timeEnd('wrapping schema');
            }
            // console.log('wrapping schema', vm.$schema);
            // }
            // tslint:disable-next-line: no-console
            // console.log('wraptime', new Date().getTime() - stime, vm.$schema);
            if (forceUpdate && (vm.$forceUpdate)) {
                vm.$forceUpdate();
            }
            return vm.$schema;
        }
    }
    /*
    destroyed() {
        const vm: any = this as any;
    },
    */
    /*
      directives: {
          schema: {
              bind: (el: any, binding: any, vnode: any) => {
                  if (vnode && vnode.componentInstance && vnode.componentInstance.setModel) {
                      vnode.componentInstance.setModel(binding.value, binding.modifiers);

                  }
              },
          },
      },
      */
};
exports.default = schemaMixin;
//# sourceMappingURL=schemaMixin.js.map